import { createHashHistory } from 'history';

/**
 * Single hash history instance for the app. Used by the Router, header (logout + redirect),
 * and login (post-login redirect) so the Router and address bar stay in sync.
 */
export default createHashHistory();